import { Outlet, useLocation } from "react-router";
import {
  BaseDataPage,
  BaseDataPageContent,
  BaseDataPageHeader,
  BaseDataPageTitle,
} from "@/routes/base-data/_components/layout/base-data-page";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";
import t from "@/lang/lang";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";
import { CollapsibleDocumentPageNavigation } from "@/shared/bsm/core/document/components/ui/document-page";

export function GfsBaseDataRoute() {
  const { pathname } = useLocation();
  const canAccess = useFeatureAuth("gsm.gfs.basedata");

  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return (
    <PersistenceContextProvider>
      <BaseDataPage>
        <BaseDataPageHeader>
          <BaseDataPageTitle>
            <span className="flex flex-wrap items-baseline gap-x-2">
              <span className="text-primary">GfS&reg;</span>
              <span>-</span>
              <span>
                <span className="text-primary">G</span>ute{" "}
                <span className="text-primary">f</span>achliche{" "}
                <span className="text-primary">S</span>chädlingsbekämpfung
              </span>
            </span>
          </BaseDataPageTitle>
        </BaseDataPageHeader>
        <BaseDataPageContent>
          <CollapsibleDocumentPageNavigation
            label={t("Navigation")}
            currentLabel={
              gfsBaseDataNavigationLinks.find((link) =>
                pathname.endsWith(`/${link.to}`),
              )?.label
            }
            maxVisibleTabs={4}
            priorityTabs={["catalog", "offer", "parameters"]}
            links={gfsBaseDataNavigationLinks}
          />
          <Outlet />
        </BaseDataPageContent>
      </BaseDataPage>
    </PersistenceContextProvider>
  );
}

const gfsBaseDataNavigationLinks = [
  { to: "catalog", label: t("Monitorkataloge") },
  { to: "offer", label: t("Angebotstexte") },
  { to: "parameters", label: t("Parameter") },
];
